<template>
  <div class="cascader-condition flex items-center flex-1">
    <el-select class="ml-3" v-model="cascadeIndex" size="small" placeholder="请选择">
      <el-option v-for="item in conditions" :key="item.value" :value="item.value" :label="item.label" />
    </el-select>
    <div v-if="cascadeIndex" class="flex-1 flex">
      <template v-if="isFill">
        <fill-condition class="flex-1" ref="condition" :data="{ optionName: data.optionName + ' 详细地址' }" />
      </template>
      <template v-else>
        <!--        <single-condition class="flex-1" ref="condition" :data="option"/>-->
        <el-select class="ml-3" v-model="condition" size="small">
          <el-option v-for="item in conditionList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
        <el-cascader
          collapse-tags
          clearable
          :show-all-levels="false"
          v-if="hasInput"
          v-model="value"
          class="ml-3 flex-1"
          size="small"
          :props="prop"
          :options="optionValue"
        ></el-cascader>
      </template>
    </div>
  </div>
</template>

<script>
import getCascaderOptions from '@/assets/js/config/cascader-config'
import { EQ, NOT_EQ, NOT_NULL, NULL, IN, NOT_IN } from '@/assets/js/config/condition-config'
import FillCondition from './FillCondition'
import SingleCondition from './SingleCondition'

export default {
  name: 'CascaderCondition',
  components: { SingleCondition, FillCondition },
  data() {
    return {
      cascadeIndex: null,
      conditions: [
        {
          label: '省份',
          value: 1
        },
        {
          label: '城市',
          value: 2
        },
        {
          label: '县/区',
          value: 3
        },
        {
          label: '详细地址',
          value: 4
        }
      ],
      conditionList: [
        {
          label: '选中',
          value: IN
        },
        {
          label: '未选中',
          value: NOT_IN
        },
        {
          label: '为空',
          value: NULL
        },
        {
          label: '不为空',
          value: NOT_NULL
        }
      ],
      option: {
        optionValue: []
      },
      options: getCascaderOptions(),
      prop: {
        expandTrigger: 'hover',
        value: 'content',
        label: 'content',
        children: 'nextLevelOptions',
        multiple: true
      },
      value: []
    }
  },
  created() {
    // console.log(cascaderOptions)
    this.condition = IN
  },
  computed: {
    isFill() {
      return this.cascadeIndex === 4
    },
    optionValue() {
      let idx = this.cascadeIndex
      return this.getCityOptions(getCascaderOptions(), idx)
    }
  },
  methods: {
    getCityOptions(options, idx) {
      return options.reduce((results, item) => {
        if (idx.toString() === item.levelNumber.toString()) {
          item.nextLevelOptions = null
        } else if (item.nextLevelOptions && item.nextLevelOptions.length) {
          item.nextLevelOptions = this.getCityOptions(item.nextLevelOptions, idx)
        } else {
          item.nextLevelOptions = null
        }
        results.push(item)
        return results
      }, [])
    },
    getValue() {
      if (this.condition === NULL || this.condition === NOT_NULL) {
        return ''
      }
      let vals = this.value.slice()
      // let val = vals.map(item => {
      //   return item.join("/")
      // }).join(",")
      let idx = this.cascadeIndex
      let val = ''
      if (idx === 1) {
        val = vals.join(',')
      } else if (idx === 2 || idx === 3) {
        let arr = []
        vals.forEach(v => {
          let item = v.slice()
          let val = item.pop()
          let k = item.join('/')
          let find = arr.find(i => i.label === k)
          if (find) {
            find.values.push(val)
          } else {
            arr.push({
              label: k,
              values: [val]
            })
          }
        })
        val = arr.reduce((res, item) => {
          if (res) {
            res = res + ','
          }
          res = res + item.label + '/' + item.values.join(',')
          return res
        }, val)
      }
      return val
    },
    getExtraParam() {
      let param = {}
      if (!this.cascadeIndex) {
        throw new Error(`${this.data.optionName}请填写要搜索的值`)
      }
      if (this.isFill) {
        try {
          param = this.$refs.condition.getExtraParam()
        } catch (e) {
          throw new Error(`${this.data.optionName}请填写要搜索的值`)
        }
      } else {
        if (!this.value.length && this.hasInput) {
          throw new Error(`${this.data.optionName}请选择要搜索的值`)
        }

        param = {
          params: this.value.map(item => item.slice().pop()),
          type: this.condition
        }

        let label = this.conditionList.find(c => c.value === this.condition).label
        let cascader = this.conditions.find(c => c.value === this.cascadeIndex).label
        let showText = this.data.optionName + ' ' + cascader + ' ' + label + ' ' + this.getValue()
        Object.defineProperty(param, 'showText', {
          value: showText,
          enumerable: false
        })
      }

      return Object.assign(param, {
        cascadeIdx: this.cascadeIndex
      })
    }
  }
}
</script>

<style scoped></style>
